import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AppFooterComponent } from './footer/footer.component';
import { AppHeaderComponent } from './header/header.component';
import { AppSidebarComponent } from './sidebar/sidebar.component';
import { SidePaneComponent } from './sidepane/sidepane.component';
import { LayoutService } from '../services/layout.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    AppSidebarComponent,
    AppHeaderComponent,
    AppFooterComponent,
    RouterOutlet,
    SidePaneComponent
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class AppLayoutComponent implements OnInit, OnDestroy {
  isLayoutCollapsed = false;
  isSidePaneVisible = false;
  private destroy$ = new Subject<void>();

  constructor(private layoutService: LayoutService) {}

  ngOnInit(): void {
    // Subscribe to right panel visibility changes
    this.layoutService.isVisible$
      .pipe(takeUntil(this.destroy$))
      .subscribe(visible => {
        this.isSidePaneVisible = visible;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSidebarCollapsed(collapsed: boolean) {
    this.isLayoutCollapsed = collapsed;
  }
}
